import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Sidebar from '../../components/Sidebar';
import Footer from '../../components/Footer';
import { useCart } from '../../context/CartContext';
import { Helmet } from 'react-helmet';
import BackgroundImage from '../../images/yale_golf_course.jpg';

const SERVER_URL = process.env.REACT_APP_SERVER_URL || (
  typeof window !== 'undefined' && window.location.hostname !== 'localhost'
    ? `${window.location.origin}/api`
    : 'http://localhost:4000'
);

const page = {
  backgroundImage: `linear-gradient(rgba(13,24,16,0.55), rgba(13,24,16,0.85)), url(${BackgroundImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundAttachment: 'fixed',
  minHeight: '100vh',
};

const wrap = { paddingTop: '140px', paddingBottom: '80px', display: 'flex', justifyContent: 'center' };
const box  = {
  background: 'rgba(13,24,16,0.7)',
  border: '1px solid rgba(184,137,42,0.3)',
  borderRadius: '8px',
  padding: '52px 48px',
  maxWidth: '560px',
  width: '90%',
  textAlign: 'center',
};

const checkmark = { fontSize: '52px', marginBottom: '16px' };

const heading = {
  fontFamily: 'Playfair Display, Georgia, serif',
  fontSize: '32px',
  fontWeight: 700,
  color: '#F5EFE3',
  marginBottom: '14px',
};

const sub = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '16px',
  color: '#C4A875',
  lineHeight: 1.6,
  marginBottom: '10px',
};

const detail = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '14px',
  color: '#8A8A82',
  marginBottom: '32px',
};

const divider = { border: 'none', borderTop: '1px solid rgba(184,137,42,0.2)', margin: '28px 0' };

const lineItem = {
  display: 'flex',
  justifyContent: 'space-between',
  fontFamily: 'Raleway, sans-serif',
  fontSize: '14px',
  color: '#C4A875',
  marginBottom: '8px',
};

const totalRow = {
  display: 'flex',
  justifyContent: 'space-between',
  fontFamily: 'Raleway, sans-serif',
  fontSize: '18px',
  fontWeight: 700,
  color: '#B8892A',
  marginTop: '12px',
  paddingTop: '12px',
  borderTop: '1px solid rgba(184,137,42,0.25)',
};

const btnWrap = { display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '32px', flexWrap: 'wrap' };

const primaryBtn = {
  padding: '12px 32px', background: '#B8892A', color: '#F5EFE3',
  border: '2px solid #B8892A', borderRadius: '4px',
  fontFamily: 'Raleway, sans-serif', fontWeight: 600, fontSize: '12px',
  letterSpacing: '2px', textTransform: 'uppercase', cursor: 'pointer', textDecoration: 'none',
};

const outlineBtn = {
  padding: '12px 32px', background: 'transparent', color: '#B8892A',
  border: '2px solid #B8892A', borderRadius: '4px',
  fontFamily: 'Raleway, sans-serif', fontWeight: 600, fontSize: '12px',
  letterSpacing: '2px', textTransform: 'uppercase', cursor: 'pointer', textDecoration: 'none',
};

function CheckoutSuccess() {
  const [isOpen, setIsOpen] = useState(false);
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  const [params] = useSearchParams();
  const sessionId = params.get('session_id');

  const { clearCart } = useCart();

  useEffect(() => {
    if (!sessionId) { setLoading(false); return; }

    fetch(`${SERVER_URL}/checkout-session?session_id=${encodeURIComponent(sessionId)}`)
      .then((r) => r.json())
      .then((data) => {
        setSession(data);

        // Only clear local cart after Stripe confirms payment is complete.
        if (data?.payment_status === 'paid') {
          clearCart();
        }

        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [sessionId, clearCart]);

  const fmt = (cents) => '$' + (cents / 100).toFixed(2);
  const toggle = () => setIsOpen((o) => !o);

  return (
    <>
      <Helmet><title>Order Confirmed – Fairway Hunters</title></Helmet>
      <Sidebar isopen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />

      <div style={page}>
        <div style={wrap}>
          <div style={box}>
            <div style={checkmark}>✓</div>
            <h1 style={heading}>Order Confirmed!</h1>
            <p style={sub}>Thank you for your purchase. We'll be in touch soon.</p>

            {loading && <p style={detail}>Loading order details…</p>}

            {session && !loading && (
              <>
                {session.customer_email && (
                  <p style={detail}>
                    A confirmation will be sent to <strong style={{ color: '#C4A875' }}>{session.customer_email}</strong>.
                  </p>
                )}

                {session.line_items?.length > 0 && (
                  <>
                    <hr style={divider} />
                    {session.line_items.map((li, i) => (
                      <div key={i} style={lineItem}>
                        <span>{li.description} × {li.quantity}</span>
                        <span>{fmt(li.amount_total)}</span>
                      </div>
                    ))}
                    {session.amount_total != null && (
                      <div style={totalRow}>
                        <span>Total Charged</span>
                        <span>{fmt(session.amount_total)}</span>
                      </div>
                    )}
                  </>
                )}
              </>
            )}

            <div style={btnWrap}>
              <a href='/shop' style={primaryBtn}>Continue Shopping</a>
              <a href='/'     style={outlineBtn}>Go Home</a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default CheckoutSuccess;
